import RichTextHtmlViewer from '@/components/RichTextHtmlViewer';
import { Image } from 'antd';
import type { SamplingImage } from './types';
import { sanitizeGuideHtml } from './guideHtml';

export function SamplingGuideText({
  value,
  format
}: {
  value?: string;
  format?: 'text' | 'html';
}) {
  if (!value) return null;
  return format === 'html' ? (
    <RichTextHtmlViewer html={sanitizeGuideHtml(value)} />
  ) : (
    <span className="whitespace-pre-wrap break-words">{value}</span>
  );
}

export function SamplingGuideMedia({
  items = [],
  imageSize = 56,
  gap = 8,
  previewZIndex,
  onPreviewVisibleChange
}: {
  items?: SamplingImage[];
  imageSize?: number;
  gap?: number;
  previewZIndex?: number;
  onPreviewVisibleChange?: (visible: boolean) => void;
}) {
  return (
    <div className="flex flex-wrap" style={{ gap }}>
      {items
        .filter((item) => /^https?:\/\//i.test(item.src))
        .map((item, index) =>
          item.type === 'video' ? (
            <video
              key={`${item.src}-${index}`}
              src={item.src}
              controls
              preload="metadata"
              playsInline
              className="max-h-[180px] max-w-full rounded-lg"
            />
          ) : (
            <Image
              key={`${item.src}-${index}`}
              src={item.src}
              alt={item.fileName || ''}
              width={imageSize}
              height={imageSize}
              preview={{
                zIndex: previewZIndex,
                onVisibleChange: (visible) => {
                  onPreviewVisibleChange?.(visible);
                  if (visible && previewZIndex !== undefined) {
                    requestAnimationFrame(() => {
                      const preview = Array.from(
                        document.querySelectorAll<HTMLElement>(
                          '.ant-image-preview-wrap'
                        )
                      ).find(
                        (element) =>
                          getComputedStyle(element).display !== 'none'
                      );
                      preview?.focus({ preventScroll: true });
                    });
                  }
                }
              }}
              className="rounded-md object-cover"
            />
          )
        )}
    </div>
  );
}
